import { loggedIn, invoiceNeedsPaying } from '../../../routes/conditional';
import paths from '../../../routes/paths';

// eslint-disable-next-line import/prefer-default-export
export const page = {
  path: paths.checkout.orderApproved,
  isAllowed: [loggedIn, invoiceNeedsPaying],
};
